import React from 'react';
import SetupConnectObjectPage from './SetupConnectObjectPage';

const SetupRoutingProfilePage = () => (
  <SetupConnectObjectPage
    pageTitle="Setup Routing Profile"
    pageSubtitle="Upload JSON to create routing profiles for a selected Amazon Connect instance"
    objectLabel="Routing Profile"
    endpointKey="routingProfileApi"
    presignType="routing-profile"
    sampleFile="sample_routing_profile_upload.json"
    acceptedKeys={["routing_profiles", "items"]}
    requiredFields={["Name", "Description", "DefaultOutboundQueueId", "MediaConcurrencies"]}
  />
);

export default SetupRoutingProfilePage;
